import { motion } from 'framer-motion';
import React from 'react';
import Background from '../images/home-bg.jpg';
import Logo from '../images/oticon-more-logo.png';

export default function Home() {
  return (
    <div id="home-page">
      <motion.img
        src={Logo}
        id="oticon-more-logo"
        initial={{ opacity: 0, y: -25 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
      />
      <motion.div
        id="tagline"
        initial={{ opacity: 0, y: -25 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 1 }}
      >
        Introducing the new perspective in hearing care
      </motion.div>
      <img src={Background} className="full-bg" />
    </div>
  );
}
